document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".slideshow-wrap").forEach(initSlideshow);
});

function initSlideshow(slideshowWrap) {
  const track = slideshowWrap.querySelector(".track");
  const sideshow = slideshowWrap.querySelector(".sideshow");
  const paginator = slideshowWrap.querySelector(".paginator");
  const prevBtn = slideshowWrap.querySelector(".nav-left button");
  const nextBtn = slideshowWrap.querySelector(".nav-right button");

  const hardcodedSlides = Array.from(track.querySelectorAll(".slide:not(.clone)"));
  const realCount = hardcodedSlides.length;

  let index = 1;
  let transitioning = false;
  let trackWidth = 0;
  let slideWidth = 0;
  let gap = 24;
  let centerOffset = 0;

  function setupClones() {
    const cloneLast = hardcodedSlides[hardcodedSlides.length - 1].cloneNode(true);
    const cloneFirst = hardcodedSlides[0].cloneNode(true);
    cloneLast.classList.add("clone");
    cloneFirst.classList.add("clone");

    track.insertBefore(cloneLast, hardcodedSlides[0]);
    track.appendChild(cloneFirst);
  }
  function recalcLayout() {
    const containerRect = sideshow.getBoundingClientRect();
    trackWidth = containerRect.width;

    const slidePct = window.innerWidth <= 740 ? 90 : 68;
    slideWidth = Math.round(trackWidth * (slidePct / 100));

    gap = 24;
    centerOffset = Math.round((trackWidth - slideWidth) / 2);

    Array.from(track.children).forEach((s) => {
      if (s instanceof HTMLElement) s.style.flexBasis = slideWidth + "px";
    });

    jumpToIndex(index, false);
  }

  function updateTransform(withTransition = true) {
    track.style.transition = withTransition ? "" : "none";
    const shift = index * (slideWidth + gap) - centerOffset;
    track.style.transform = `translateX(${-shift}px)`;
  }

  function jumpToIndex(newIndex, withTransition = true) {
    index = newIndex;
    updateTransform(withTransition);
    requestAnimationFrame(updateActiveVideo);
  }

  function go(offset) {
    if (transitioning) return;
    transitioning = true;
    disableNav(true);
    index += offset;
    updateTransform(true);
  }

  function currentRealIndex() {
    let realIndex = index - 1;
    return ((realIndex % realCount) + realCount) % realCount;
  }

  function updateActiveVideo() {
    const activeIndex = currentRealIndex();
    const videos = track.querySelectorAll("video");
    videos.forEach((v) => {
      if (Number(v.dataset.index) === activeIndex) {
        v.muted = true;
        v.play().catch(() => {});
      } else {
        v.pause();
      }
    });
  }

  function buildPaginator() {
    paginator.innerHTML = "";
    const useNumbers = realCount > 1;

    for (let i = 0; i < realCount; i++) {
      const el = document.createElement("div");
      el.className = useNumbers ? "num" : "dot";
      el.dataset.target = i;
      if (useNumbers) el.textContent = i + 1;

      el.addEventListener("click", () => {
        if (!transitioning) {
          index = i + 1;
          go(0);
        }
      });

      paginator.appendChild(el);
    }

    refreshPaginatorActive();
  }

  function refreshPaginatorActive() {
    const activeReal = currentRealIndex();
    Array.from(paginator.children).forEach((dot) => {
      dot.classList.toggle(
        "active",
        Number(dot.dataset.target) === activeReal
      );
    });
  }

  function setupPointerEvents() {
    let pointer = { down: false, startX: 0 };

    sideshow.addEventListener("pointerdown", (e) => {
      if (e.target.closest("button")) return;
      pointer.down = true;
      pointer.startX = e.clientX;
      track.style.transition = "none";
      sideshow.setPointerCapture?.(e.pointerId);
    });

    sideshow.addEventListener("pointermove", (e) => {
      if (!pointer.down) return;
      const dx = e.clientX - pointer.startX;
      const baseShift = index * (slideWidth + gap) - centerOffset;
      track.style.transform = `translateX(${-(baseShift - dx)}px)`;
    });

    function endPointer(e) {
      if (!pointer.down) return;
      pointer.down = false;
      const dx = e.clientX - pointer.startX;
      track.style.transition = "";

      const threshold = Math.max(24, slideWidth * 0.12);
      if (dx > threshold) go(-1);
      else if (dx < -threshold) go(1);
      else updateTransform(true);

      try {
        sideshow.releasePointerCapture?.(e.pointerId);
      } catch (err) {}
    }

    sideshow.addEventListener("pointerup", endPointer);
    sideshow.addEventListener("pointercancel", endPointer);
    sideshow.addEventListener("pointerleave", endPointer);
  }

  function disableNav(val) {
    [prevBtn, nextBtn].forEach((btn) => {
      btn.style.opacity = val ? "0.5" : "1";
      btn.style.pointerEvents = val ? "none" : "";
    });
  }

  track.addEventListener("transitionend", (e) => {
    if (e.propertyName !== "transform") return;

    transitioning = false;
    disableNav(false);

    if (index === 0) index = realCount;
    else if (index === realCount + 1) index = 1;

    updateTransform(false);
    updateActiveVideo();
    refreshPaginatorActive();
  });

  prevBtn.addEventListener("click", (e) => {
    e.preventDefault();
    go(-1);
  });
  nextBtn.addEventListener("click", (e) => {
    e.preventDefault();
    go(1);
  });

  window.addEventListener("resize", recalcLayout);

  setupClones();
  buildPaginator();
  recalcLayout();
  setupPointerEvents();
  requestAnimationFrame(() => jumpToIndex(1, false));
}
